import * as _ from 'underscore'

import { OpConfigurationProfile } from '../../../models/core'
import { Enums } from '../../../models/common/enums'
import { IOpObject } from '../../../models/util/interfaces'

import { EventsNames, LocalizationHelper, CommonHelper, LogHelper } from '../../../helpers'

import { CreateEditController, CreateEditScope } from '../../common/common.create-edit.controller'
import { CreateEditInitParams, CreateEditPopupOptions } from '../../common/create-edit-popup/create-edit-popup.controller'
import { UserSessionService } from '../../../services/user-session'
import { ConfigurationProfileService } from '../../../services/configuration-profile'
import { CreateEditSection } from '../../../modules/common/common.create-edit'



interface ConfigurationProfileCreateEditScope extends CreateEditScope {
    options: CreateEditPopupOptions
}

const OPEN_POPUP_EVENT_NAME: string = `CONFIGURATION_PROFILE_OPEN_CREATE_EDIT_POPUP`

export class ConfigurationProfileCreateEditController extends CreateEditController {

    // Consts

    private static get LOG_STRING(): string { return '[SIMAX.COnfigurationProfile.KonfigurationProfileCreateEditDirective] - %s' }

    // Consts End

    // Members

    private referenceValue: OpConfigurationProfile;

    private deferForSaving: ng.IDeferred<IOpObject> = null
    private objectToSave: OpConfigurationProfile

    private needHideLoadingIndicator: boolean

    // Members End

    // #region Ctor

    constructor(
        protected $scope: ConfigurationProfileCreateEditScope,
        private $q: ng.IQService,
        private $timeout: ng.ITimeoutService,
        protected userSession: UserSessionService,
        public referenctType: Enums.ReferenceType,
        private moduleName: Enums.SimaxModuleName,
        protected configurationProfileService: ConfigurationProfileService
    ) {
        super(referenctType)

        this.setEvents()
        this.setOptions()
    }


    //#region  Setup

    private setEvents(): void {
        this.$scope.$on(
            OPEN_POPUP_EVENT_NAME,
            (event: ng.IAngularEvent, ...args: any[]) => this.onInit(args)
        )
    }

    private setOptions(): void {
        this.$scope.noText = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.No)
        this.$scope.confirmChangesText = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Confirm)

        this.$scope.options = {
            onSubmit: null,
            onClose: null,
            referenceType: Enums.ReferenceType.IdConfigurationProfile,
            submitBulkEdit: null,
            succsessMessage: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__SAVED, ConfigurationProfileService.SIMAX_MODULE_NAME),
            title: '',
            type: null,

            onBulkSave: null,
            onSave: (objectToSave: IOpObject): ng.IPromise<IOpObject> => this.onSave(objectToSave),
        }


    }

    //#endregion Setup End

    //#region  Events        

    private onInit(args: any[]): void {
        if (_.size(args) > 0) {
            const createEditInitParams: CreateEditInitParams = args[0]

            if (createEditInitParams.isCopy === true) {
                createEditInitParams.referenceObjectId = 0

                if (createEditInitParams.referenceObject != null) {
                    createEditInitParams.referenceObject.idObject = 0
                }
            }

            this.referenceValue = createEditInitParams ? <OpConfigurationProfile>createEditInitParams.referenceObject : null
            this.$scope.$broadcast(EventsNames.SHOW_CREATE_EDIT_POPUP)

            if (this.referenceValue != null && this.referenceValue.idObject > 0) {
                this.$scope.options.title = LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__EDITING, ConfigurationProfileService.SIMAX_MODULE_NAME)
            } else {
                this.$scope.options.title = LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__ADDING, ConfigurationProfileService.SIMAX_MODULE_NAME)
            }

            const formSection: CreateEditSection = _.find(createEditInitParams.sections, (section: CreateEditSection) => section.type === 'form')


            if (formSection != null) {
                formSection.dataTypesToEdit = formSection.dataTypesToEdit
                createEditInitParams.sections = [formSection]
            } else {
                createEditInitParams.sections = []
            }

            this.$scope.$broadcast(EventsNames.OPEN_CREATE_EDIT_POPUP_CONFIGURATION_PROFILE, createEditInitParams)
        }
    }

    private onSave(objectToSave: IOpObject): ng.IPromise<IOpObject> {
        const defer: ng.IDeferred<IOpObject> = this.$q.defer()

        this.configurationProfileService
            .saveConfigurationProfile(<OpConfigurationProfile>objectToSave)
            .then((savedObject: OpConfigurationProfile) => {
                CommonHelper.setValueToLocalStorage(CommonHelper.localStorageVarForSavedEntity.locationSaved, true, 0)
                this.$scope.$root.$broadcast(EventsNames.CLOSE_CREATE_EDIT_POPUP, savedObject)

                defer.resolve(savedObject)
            })
            .fail((error: any) => {
                LogHelper.error(ConfigurationProfileService.LOG_PREFIX, error)
                defer.reject(error)
            })

        return defer.promise

    }

    //#endregion
}